import { render } from "./AlertsTable.vue?vue&type=template&id=57d74bf2&scoped=true"
import script from "./AlertsTable.vue?vue&type=script&lang=js"
export * from "./AlertsTable.vue?vue&type=script&lang=js"

import "@/assets/table.css?vue&type=style&index=0&id=57d74bf2&scoped=true&lang=css&external"
import "./AlertsTable.vue?vue&type=style&index=1&id=57d74bf2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57d74bf2"]])

export default __exports__